import { defineMessages } from 'react-intl';

const messages = defineMessages({
  email: {
    id: 'app.email',
    defaultMessage: 'Email Address',
    description: 'Your Email Address to Login',
  },
  emailRequired: {
    id: 'app.emailRequired',
    defaultMessage: 'Email is required',
    description: 'Email is required',
  },
  emailInvalid: {
    id: 'app.emailInValid',
    defaultMessage: 'Invalid Email Address',
    description: 'Invalid Email Address',
  },
  emailNotExists: {
    id: 'app.emailNotExists',
    defaultMessage: 'No account exists for this email. Make sure it\'s typed in correctly, or “sign up” instead',
    description: 'Email Address is not exist',
  },
  password: {
    id: 'app.password',
    defaultMessage: 'Password',
    description: 'Your Password to Login',
  },
  passwordRequired: {
    id: 'app.passwordRequired',
    defaultMessage: 'Password is required',
    description: 'Password is required',
  },
  passwordInvalid: {
    id: 'app.passwordInValid',
    defaultMessage: 'Your password must be at least 8 characters. Please try again',
    description: 'Invalid Password',
  },
  passwordWrong: {
    id: 'app.passwordWrong',
    defaultMessage: 'Wrong Password. Please try again',
    description: 'Wrong Password',
  },
  somethingWentWrong: {
    id: 'app.somethingWentWrong',
    defaultMessage: 'Sorry, something went wrong. Please try again',
    description: 'Wrong went wrong',
  },
  loggedIn: {
    id: 'app.loggedIn',
    defaultMessage: 'You are already logged in!',
    description: 'You are already Logged-in',
  },
  userLoggedIn: {
    id: 'app.userLoggedIn',
    defaultMessage: 'You are already logged in as User, please logout in the main site to continue!',
    description: 'You are already Logged-in as user',
  }

});

export default messages;
